export default "__VITE_ASSET__7f6e9e4a__"